<template>
  <el-input v-model="file_path" placeholder="可输入文件路径">
    <template #append>
      <el-upload
          :action="action"
          :headers="headers"
          :show-file-list="false"
          :on-success="handleSuccess"
          :before-upload="beforeUpload">
        <div style="display: flex;align-items: center">
          <text>上传</text><el-icon class="el-icon--right"><Upload /></el-icon>
        </div>
      </el-upload>
    </template>
  </el-input>
</template>
<script>
import { getApiTokenHeaders } from '../../utils/backendAuth';

export default {
  props:['modelValue'],
  emits: ['update:modelValue'],
  data() {
    return {
      action:'/api/file',
      headers: getApiTokenHeaders(),
      file_path : "",
    };
  },
  methods: {
    handleSuccess(e) {
        const {code,data,message} = e;
        this.$emit('update:modelValue',data.path);
    },
    beforeUpload(e) {
      //console.log(e);
    }
  },
  watch: {
    file_path(e){
      this.$emit('update:modelValue',e);
    },
    modelValue(e){
      this.file_path = e;
    }
  },
  mounted() {

  }
}
</script>
<style scoped>

</style>
